import { createDeepEqualSelector } from "../utils";

import type { RootState } from "../types";

export const selectAccountHolds = createDeepEqualSelector(
  (state: RootState) => state.accountHolds?.byId || {},
  (_, accountId: API.AccountId) => accountId,
  (byId, accountId) => byId?.[accountId] || {},
);
